<template>
  <page-view :title="$t('commerce.tickets')" backLink="/dashboard" backText="Back to Dashboard">
    <template v-slot:header-right v-if="[1, 6, 15, 16].includes(user.permission_id)">
      <Button @click="$router.push('/tickets/add')">Create ticket</Button>
    </template>
    <table-list>
      <tr class="header">
        <th class="w-100p w-md-50p">Ticket</th>
        <th class="w-10p only-desktop ta-c">Created</th>
        <th class="w-20p only-desktop ta-c">Expiration</th>
        <th class="w-10p only-desktop ta-c">Single access</th>
        <th class="w-10p only-desktop ta-c">Price</th>
        <th class="w-10p extra-padding"></th>
      </tr>
      <a :href="`/ticket/${ticket.id}`" @click.prevent="handleLink($event, `/ticket/${ticket.id}`)" v-for="(ticket, index) in tickets" :key="index">
        <td class="strong ellipsis">
          <div class="blue">{{ ticket.name }}</div>
        </td>
        <td class="ta-c only-desktop">{{ ticket.created_at | formatdate }}</td>
        <td class="ta-c only-desktop">{{ expires(ticket) }}</td>
        <td class="ta-c only-desktop">{{ ticket.access.single_access ? 'Single' : 'Multiple' }}</td>
        <td class="ta-c only-desktop">{{ ticket.prices ? ticket.prices.length > 0 ? ticket.prices[0].formated_price : 'N/A' : 'N/A' }}</td>
        <td class="extra-padding blue"><i class="arrow mdi mdi-chevron-right"></i></td>
      </a>
    </table-list>
    <pagination class="m-t-4 m-b-2" :page="currentpage" :maxPage="maxpage" @page="paginate" />
  </page-view>
</template>

<script>

import TableList from '@/components/Lists/Table.vue';
import Pagination from '@/components/Lists/Pagination.vue';

export default {
  components: {
    TableList,
    Pagination,
  },
  methods: {
    /**
     * Get a list of tickets base on parameters
     * @returns {Void}
     */
    async getTickets() {
      const { products, pagination } = await this.$store.dispatch('Products/getProducts', {
        page: this.currentpage,
        sort: this.sort,
        direction: this.direction,
        per_page: this.per_page,
        type: 'stream',
        skipConf: true,
        skipState: true,
      });

      this.tickets = products;
      this.maxpage = pagination.max_page;
      this.currentpage = pagination.current_page;
    },
    paginate(page) {
      this.currentpage = page;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page,
        },
      });

      this.getTickets();
    },
    /**
     * Parse and return correct expiration string
     * @param {Object} ticket
     * @returns {String}
     */
    expires(ticket) {
      const {
        prices = [],
        access: {
          expires_at = null,
          expires_after = null,
          formated_expires,
        },
      } = ticket;

      if (!prices) {
        return 'N/A';
      }

      if (prices.length > 0 && prices[0].type === 'recurring') {
        return 'N/A';
      }

      return `${expires_at ? 'At' : ''}${expires_after ? 'After' : ''} ${formated_expires}`;
    },
  },
  data() {
    return {
      currentpage: 1,
      maxpage: 1,
      per_page: 15,
      sort: 'created',
      direction: 'desc',
      tickets: [],
    };
  },
  async mounted() {
    const {
      page = 1,
      sort = 'created',
      direction = 'desc',
    } = this.$queryHelper.get({ validSort: ['created'] });

    this.currentpage = page;
    this.sort = sort;
    this.direction = direction;

    await this.getTickets();
  },
};
</script>
